// Mock data for DumaExpertBéton website

export const companyInfo = {
  name: "DumaExpertBéton",
  slogan: "L'Excellence du Béton Décoratif",
  phone: "06 52 59 34 41",
  phoneRaw: "0033652593441",
  email: "contact@duma-expert-beton.fr",
  address: "Orange, Vaucluse (84)",
  region: "Provence-Alpes-Côte d'Azur",
  interventionRadius: "65 km autour de Sainte-Cécile-les-Vignes",
  siret: "80208114100011",
  established: "2014"
};

export const services = [
  {
    id: 1,
    title: "Béton Imprimé",
    slug: "beton-imprime",
    description: "Le béton imprimé, également connu sous le nom de béton estampé ou béton empreinte, représente la solution idéale pour transformer vos espaces extérieurs en véritables œuvres d'art. Cette technique innovante permet de reproduire fidèlement l'apparence de matériaux nobles comme la pierre naturelle, l'ardoise, le bois, la brique, ou encore les pavés, tout en bénéficiant de la robustesse et de la durabilité exceptionnelle du béton. Le processus consiste à appliquer des moules texturés sur le béton frais, créant ainsi des motifs en relief parfaitement réalistes. Les pigments de couleur intégrés dans la masse ou appliqués en surface offrent une palette infinie de teintes, permettant une personnalisation complète selon vos goûts et l'architecture de votre propriété. Avec plus de 11 ans d'expérience dans le domaine, notre équipe maîtrise parfaitement cette technique exigeante qui nécessite une expertise pointue et un timing précis. Le béton imprimé offre un rapport qualité-prix imbattable comparé aux matériaux naturels qu'il imite, tout en éliminant les inconvénients comme les joints qui se dégradent, les pavés qui bougent, ou l'entretien fastidieux du bois. La finition est protégée par une résine spéciale qui garantit la longévité des couleurs et facilite l'entretien quotidien. Cette solution convient parfaitement aux terrasses, allées, cours intérieures, plages de piscine, et même aux espaces commerciaux. La surface antidérapante assure votre sécurité, tandis que sa résistance aux intempéries, au gel, et aux UV garantit un aspect impeccable pendant des décennies. Choisir le béton imprimé, c'est opter pour l'excellence esthétique sans compromis sur la performance.",
    features: [
      "Large choix de motifs et couleurs",
      "Résistant aux intempéries",
      "Entretien minimal",
      "Durabilité exceptionnelle"
    ],
    applications: ["Terrasses", "Allées", "Cours", "Plages de piscine"],
    icon: "Stamp"
  },
  {
    id: 2,
    title: "Béton Désactivé",
    slug: "beton-desactive",
    description: "Le béton désactivé, aussi appelé béton lavé ou béton apparent, est une technique de revêtement extérieur qui révèle la beauté naturelle des granulats contenus dans le béton. Ce procédé sophistiqué consiste à pulvériser un désactivant de surface sur le béton fraîchement coulé, puis à laver la couche superficielle de ciment après durcissement, dévoilant ainsi les graviers colorés en relief. Le résultat est une surface au rendu minéral authentique, élégante et résolument contemporaine, qui s'intègre harmonieusement dans tous les environnements paysagers. Les granulats apparents créent une texture naturellement antidérapante, faisant du béton désactivé le choix privilégié pour les abords de piscine, les rampes d'accès, et toutes les zones où la sécurité est primordiale. Cette solution écologique et perméable favorise l'infiltration des eaux de pluie, contribuant ainsi à une gestion durable de l'eau sur votre propriété. La diversité des granulats disponibles (marbre, quartz, gravier de rivière, pierre concassée) permet de créer des ambiances variées, du plus sobre au plus coloré. Notre expertise de plus de 11 ans nous permet de maîtriser parfaitement le dosage du désactivant et le timing du lavage, garantissant un résultat homogène et durable sur l'ensemble de la surface. Le béton désactivé ne nécessite pratiquement aucun entretien et conserve son aspect d'origine pendant des décennies. Sa résistance exceptionnelle au passage de véhicules en fait également une solution idéale pour les parkings, les entrées de garage, et les voies d'accès. Contrairement aux graviers traditionnels qui se dispersent et nécessitent un réapprovisionnement régulier, le béton désactivé reste parfaitement en place tout en offrant l'esthétique d'un sol gravillonné. C'est la combinaison parfaite entre esthétisme naturel, fonctionnalité et longévité.",
    features: [
      "Aspect naturel et élégant",
      "Antidérapant",
      "Perméable à l'eau",
      "Écologique"
    ],
    applications: ["Entrées de garage", "Parkings", "Voies piétonnes", "Espaces publics"],
    icon: "Layers"
  },
  {
    id: 3,
    title: "Béton Bâlé",
    slug: "beton-bale",
    description: "Le béton bâlé représente une technique ancestrale remise au goût du jour, offrant une finition unique qui marie parfaitement rusticité et modernité. Ce procédé artisanal consiste à balayer la surface du béton fraîchement coulé à l'aide d'un balai rigide, créant ainsi des stries parallèles qui apportent texture et caractère à la surface. Le résultat est une finition striée distinctive qui confère une identité forte à vos espaces extérieurs tout en offrant d'excellentes propriétés antidérapantes. Cette technique traditionnelle nécessite un savoir-faire précis et une grande expérience pour obtenir un rendu homogène et esthétique sur l'ensemble de la surface. Le timing d'intervention est crucial : le balayage doit être effectué au moment exact où le béton a suffisamment durci pour ne pas s'affaisser, mais reste assez malléable pour être texturé. Notre équipe, forte de plus de 11 ans d'expérience, maîtrise parfaitement ce processus délicat. Le béton bâlé offre une alternative économique et durable aux revêtements traditionnels, tout en créant une ambiance campagnarde ou contemporaine selon les coloris choisis. Les stries créées par le balayage ne sont pas seulement esthétiques : elles améliorent significativement l'adhérence, faisant du béton bâlé un choix sécuritaire pour les zones de passage, les rampes, et les espaces potentiellement glissants. Cette finition s'intègre harmonieusement dans les environnements ruraux comme urbains, apportant une touche d'authenticité et de chaleur. Le béton bâlé est particulièrement résistant aux conditions climatiques extrêmes et supporte sans problème le passage répété de véhicules. Son entretien est minimal : un simple nettoyage à l'eau suffit pour conserver son aspect d'origine. Cette technique polyvalente convient parfaitement aux cours, chemins, zones de stationnement, et espaces publics, offrant un excellent rapport qualité-prix tout en garantissant longévité et esthétique.",
    features: [
      "Texture distinctive",
      "Effet antidérapant",
      "Résistant",
      "Esthétique originale"
    ],
    applications: ["Extérieurs", "Zones de passage", "Cours", "Chemins"],
    icon: "Grip"
  },
  {
    id: 4,
    title: "Béton Lissé",
    slug: "beton-lisse",
    description: "Le béton lissé incarne l'élégance minimaliste et la modernité architecturale. Cette technique de finition produit une surface parfaitement plane, lisse et uniforme, créant un rendu contemporain et épuré qui sublime vos espaces extérieurs. Le processus de lissage nécessite une expertise technique pointue : après le coulage, la surface est soigneusement travaillée à l'aide de lisseuses mécaniques et manuelles, éliminant toute irrégularité et créant une texture soyeuse au toucher. Notre équipe expérimentée maîtrise les gestes précis et le timing parfait nécessaires pour obtenir une finition impeccable sans défauts. Le béton lissé se distingue par son aspect raffiné et sa capacité à refléter subtilement la lumière, créant des jeux d'ombres et de lumières qui évoluent au fil de la journée. Cette finition est particulièrement prisée pour les plages de piscine, où elle offre une transition harmonieuse entre l'eau et la terrasse, tout en facilitant le nettoyage et l'entretien. Les terrasses en béton lissé deviennent de véritables extensions de votre espace de vie intérieur, créant une continuité visuelle élégante. La palette de couleurs disponibles permet de créer des ambiances variées, du gris anthracite contemporain aux teintes chaudes de terre cuite, en passant par le blanc immaculé. Le béton lissé peut être traité avec des résines de protection spéciales qui renforcent sa résistance aux taches, aux UV, et aux intempéries, tout en accentuant sa profondeur de couleur. Cette finition convient parfaitement aux espaces intérieurs comme extérieurs, apportant une touche de sophistication intemporelle. Sa surface lisse facilite grandement l'entretien quotidien et son caractère minimaliste s'adapte à tous les styles architecturaux. Choisir le béton lissé, c'est opter pour une esthétique pure et durable qui valorisera votre propriété pendant des décennies.",
    features: [
      "Surface parfaitement plane",
      "Finition moderne et épurée",
      "Entretien très facile",
      "Idéal intérieur et extérieur"
    ],
    applications: ["Plages de piscine", "Terrasses modernes", "Showrooms", "Espaces commerciaux"],
    icon: "Minimize"
  },
  {
    id: 5,
    title: "Béton Ciré",
    slug: "beton-cire",
    description: "Le béton ciré représente l'excellence et le summum du raffinement dans l'univers des revêtements décoratifs. Cette finition haut de gamme combine l'esthétique du béton avec la douceur et la brillance d'une surface cirée, créant un résultat absolument unique qui transforme n'importe quel espace en une œuvre d'art. Le béton ciré est un revêtement fin de quelques millimètres d'épaisseur, composé de ciment, de résines, de pigments et de fines particules minérales, appliqué en plusieurs couches successives puis poli et ciré pour obtenir une finition soyeuse et satinée. Cette technique artisanale exige une expertise exceptionnelle et une maîtrise parfaite des proportions et des temps de séchage entre chaque couche. Notre équipe, forte de plus de 11 ans d'expérience, réalise des finitions en béton ciré d'une qualité irréprochable, sans joints apparents sur de grandes surfaces. Le béton ciré offre une palette de couleurs quasi infinie et peut être teinté dans la masse ou coloré en surface, permettant de créer des ambiances personnalisées et exclusives. Sa finition brillante ou mate, selon votre préférence, apporte profondeur et luminosité aux espaces, tout en créant une sensation de continuité et d'ampleur. Particulièrement apprécié en intérieur pour les sols, murs, plans de travail et salles de bains, le béton ciré convient également aux espaces extérieurs protégés comme les terrasses couvertes ou les porches. Sa résistance remarquable aux taches, à l'humidité et à l'usure en fait un choix privilégié pour les espaces à fort passage comme les commerces, restaurants, hôtels et showrooms. L'entretien du béton ciré est simple : un nettoyage régulier avec des produits doux suffit, et l'application occasionnelle d'une cire protectrice préserve son aspect brillant. Le béton ciré crée une ambiance chaleureuse et sophistiquée, apportant une touche de luxe moderne à votre intérieur. C'est le choix ultime pour ceux qui recherchent l'exclusivité, l'élégance intemporelle et la performance durable.",
    features: [
      "Finition haut de gamme",
      "Sans joints, aspect continu",
      "Résistant à l'eau et aux taches",
      "Large palette de couleurs"
    ],
    applications: ["Intérieurs", "Terrasses couvertes", "Commerces", "Espaces premium"],
    icon: "Sparkles"
  }
];

export const projects = [
  {
    id: 1,
    title: "Terrasse Moderne - Avignon",
    category: "Béton Imprimé",
    surface: "120m²",
    location: "Avignon",
    year: "2024",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=800"
  },
  {
    id: 2,
    title: "Allée de Jardin - Orange",
    category: "Béton Désactivé",
    surface: "85m²",
    location: "Orange",
    year: "2024",
    image: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=800"
  },
  {
    id: 3,
    title: "Plage de Piscine - Carpentras",
    category: "Béton Lissé",
    surface: "95m²",
    location: "Carpentras",
    year: "2023",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=800"
  },
  {
    id: 4,
    title: "Cour Privée - Châteauneuf",
    category: "Béton Bâlé",
    surface: "150m²",
    location: "Châteauneuf-du-Pape",
    year: "2023",
    image: "https://images.unsplash.com/photo-1600047509358-9dc75507daeb?w=800"
  },
  {
    id: 5,
    title: "Showroom Commercial - Monteux",
    category: "Béton Ciré",
    surface: "200m²",
    location: "Monteux",
    year: "2024",
    image: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800"
  },
  {
    id: 6,
    title: "Entrée Résidentielle - Sorgues",
    category: "Béton Imprimé",
    surface: "65m²",
    location: "Sorgues",
    year: "2024",
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie Dubois",
    location: "Avignon",
    rating: 5,
    text: "Travail exceptionnel ! Notre terrasse en béton imprimé est magnifique. L'équipe est professionnelle et très à l'écoute.",
    date: "Janvier 2024",
    project: "Terrasse 120m²"
  },
  {
    id: 2,
    name: "Jean-Pierre Martin",
    location: "Orange",
    rating: 5,
    text: "Prestation impeccable du début à la fin. Le béton désactivé correspond exactement à nos attentes. Je recommande vivement !",
    date: "Décembre 2023",
    project: "Allée de jardin"
  },
  {
    id: 3,
    name: "Sophie Laurent",
    location: "Carpentras",
    rating: 5,
    text: "Très satisfaits du résultat ! La plage de piscine est superbe et résistante. Un grand merci pour le conseil et la qualité.",
    date: "Février 2024",
    project: "Plage de piscine"
  },
  {
    id: 4,
    name: "Patrick Bernard",
    location: "Châteauneuf-du-Pape",
    rating: 5,
    text: "Entreprise sérieuse et compétente. Le béton bâlé de notre cour est parfait. Délais respectés et prix correct.",
    date: "Novembre 2023",
    project: "Cour 150m²"
  }
];

export const faqs = [
  // Questions Générales
  {
    id: 1,
    category: "Général",
    question: "Qu'est-ce que le béton décoratif ?",
    answer: "Le béton décoratif est un revêtement de sol extérieur qui combine la résistance du béton traditionnel avec des finitions esthétiques variées. Il existe plusieurs techniques : béton imprimé (avec motifs), béton désactivé (granulats apparents) et béton bâlé (texture balayée)."
  },
  {
    id: 2,
    category: "Général",
    question: "Quelle est la différence entre béton imprimé et béton désactivé ?",
    answer: "Le béton imprimé reçoit des empreintes de motifs (pierre, bois, brique) pendant qu'il est frais. Le béton désactivé révèle les granulats en surface en retirant la couche superficielle de ciment, créant un aspect naturel et granuleux."
  },
  {
    id: 3,
    category: "Général",
    question: "Qui est DumaExpertBéton ?",
    answer: "DumaExpertBéton est une entreprise fondée en 2014 (SIRET 80208114100011), spécialisée dans le béton décoratif. Basée à Sainte-Cécile-les-Vignes (84290), nous intervenons dans un rayon de 65 km avec plus de 11 ans d'expérience et 2000+ projets réalisés représentant plus de 500,000 m² de surfaces traitées."
  },
  
  // Durabilité et Qualité
  {
    id: 4,
    category: "Durabilité",
    question: "Quelle est la durée de vie du béton imprimé ?",
    answer: "Le béton imprimé a une durée de vie de 20 à 30 ans avec un entretien approprié. Certaines réalisations peuvent durer plus de 40 ans si les conditions d'entretien et d'utilisation sont optimales."
  },
  {
    id: 5,
    category: "Durabilité",
    question: "Le béton décoratif résiste-t-il au gel ?",
    answer: "Oui, le béton décoratif est résistant au gel lorsqu'il est correctement dosé et traité. Nous utilisons des adjuvants antigel et appliquons une résine de protection qui empêche la pénétration de l'eau, principale cause des dégâts dus au gel."
  },
  {
    id: 6,
    category: "Durabilité",
    question: "Est-ce que le béton décoratif se fissure ?",
    answer: "Comme tout béton, des microfissures peuvent apparaître avec le temps. Pour les minimiser, nous réalisons des joints de dilatation, utilisons un ferraillage adapté et respectons les dosages professionnels. Les fissures esthétiques éventuelles sont généralement minimes."
  },
  {
    id: 7,
    category: "Durabilité",
    question: "Le béton imprimé peut-il se décolorer ?",
    answer: "Les pigments de qualité professionnelle que nous utilisons sont résistants aux UV. Une légère patine naturelle peut apparaître après plusieurs années, mais l'application régulière de résine de protection (tous les 2-3 ans) maintient l'éclat des couleurs."
  },
  
  // Prix et Devis
  {
    id: 8,
    category: "Prix",
    question: "Quel est le prix du béton imprimé au m² ?",
    answer: "Le prix varie selon la complexité du motif, la superficie et l'accessibilité du chantier. En moyenne, comptez entre 77€ et 120€/m² pour du béton imprimé, incluant matériaux, main d'œuvre, déplacement (65km) et protection finale. Surface minimum 20m². Un devis gratuit et sans engagement vous donnera un prix exact pour votre projet."
  },
  {
    id: 9,
    category: "Prix",
    question: "Le béton désactivé est-il plus cher que le béton imprimé ?",
    answer: "Le béton désactivé a un tarif similaire au béton imprimé, avec un prix moyen de 77€ à 120€/m², incluant matériaux, main d'œuvre, déplacement (65km) et protection finale. Le prix final dépend du type de granulats choisis et de la surface à traiter. Surface minimum 20m²."
  },
  {
    id: 10,
    category: "Prix",
    question: "Y a-t-il des frais supplémentaires à prévoir ?",
    answer: "Le prix inclut : matériaux, main d'œuvre, déplacement (max 65km) et protection finale. NON INCLUS : préparation du terrain (terrassement - supplément séparé) et pompe à béton (facturée au prix du fournisseur, sans majoration). Devis gratuit valable 30 jours."
  },
  {
    id: 11,
    category: "Prix",
    question: "Proposez-vous des facilités de paiement ?",
    answer: "Oui, nous acceptons le paiement en plusieurs fois pour les projets importants. Un acompte de 30% est demandé à la signature du contrat. Le devis gratuit est valable 30 jours. Garantie 10 ans sur la structure du béton."
  },
  {
    id: 11.1,
    category: "Prix",
    question: "Quel est le prix du béton bâlé et lissé ?",
    answer: "Le béton bâlé et le béton lissé coûtent entre 80€ et 125€/m², incluant matériaux, main d'œuvre, déplacement (65km) et protection finale. Surface minimum 20m². Prix valables pour 2025."
  },
  {
    id: 11.2,
    category: "Prix",
    question: "Combien coûte le béton ciré ?",
    answer: "Le béton ciré est notre finition la plus premium, avec un prix entre 85€ et 135€/m², incluant matériaux, main d'œuvre, déplacement (65km) et protection finale. Idéal pour intérieurs et extérieurs. Surface minimum 20m²."
  },
  {
    id: 11.3,
    category: "Prix",
    question: "Quelle est la surface minimale pour un projet ?",
    answer: "La surface minimale pour tous nos services est de 20m². Cela nous permet d'assurer une qualité optimale et une rentabilité équitable pour le client et l'entreprise. Pour des surfaces plus petites, contactez-nous pour discuter des possibilités."
  },
  
  // Délais et Planning
  {
    id: 12,
    category: "Délais",
    question: "Combien de temps faut-il pour réaliser un projet ?",
    answer: "Pour 100m² : comptez 5-7 jours incluant préparation, coulage, impression/traitement et séchage. Les petits projets (< 50m²) prennent 3-5 jours, les grands (> 150m²) environ 2-3 semaines."
  },
  {
    id: 13,
    category: "Délais",
    question: "Combien de temps avant de pouvoir marcher dessus ?",
    answer: "Vous pouvez marcher légèrement sur le béton après 48-72 heures. Pour une circulation normale (piétons), attendez 7 jours minimum. Pour les véhicules, respectez un délai de 15 à 21 jours pour une cure complète."
  },
  {
    id: 14,
    category: "Délais",
    question: "Peut-on réaliser du béton décoratif en hiver ?",
    answer: "Oui, mais sous conditions. La température doit être entre 5°C et 30°C et sans gel prévu dans les 48h suivant la pose. En hiver, nous adaptons le dosage avec des adjuvants et protégeons le chantier si nécessaire."
  },
  {
    id: 15,
    category: "Délais",
    question: "Quel est le délai pour obtenir un devis ?",
    answer: "Vous recevez votre devis gratuit sous 24 à 48 heures après notre visite ou échange téléphonique. Pour les projets urgents, nous pouvons établir un devis le jour même."
  },
  
  // Entretien
  {
    id: 16,
    category: "Entretien",
    question: "Le béton décoratif nécessite-t-il un entretien particulier ?",
    answer: "L'entretien est minimal : nettoyage régulier à l'eau savonneuse, éviter les produits chimiques agressifs. Pour le béton imprimé, appliquez une résine de protection tous les 2-3 ans pour maintenir l'aspect et la protection."
  },
  {
    id: 17,
    category: "Entretien",
    question: "Comment nettoyer le béton imprimé ?",
    answer: "Balayage régulier et lavage au jet d'eau basse pression avec un détergent doux. Évitez les nettoyeurs haute pression qui peuvent endommager la résine de protection. Un nettoyage approfondi 2 fois par an est recommandé."
  },
  {
    id: 18,
    category: "Entretien",
    question: "Que faire si une tache apparaît ?",
    answer: "Traitez les taches rapidement. Pour l'huile : utilisez un dégraissant spécial béton. Pour les feuilles/végétaux : nettoyez rapidement pour éviter les tannins. Pour les taches tenaces : un professionnel peut poncer localement et re-sceller."
  },
  {
    id: 19,
    category: "Entretien",
    question: "La résine de protection est-elle obligatoire ?",
    answer: "Fortement recommandée mais pas obligatoire. Elle protège contre les taches, l'usure, les UV et l'eau. Elle facilite aussi l'entretien et ravive les couleurs. Son application tous les 2-3 ans prolonge significativement la durée de vie."
  },
  
  // Technique
  {
    id: 20,
    category: "Technique",
    question: "Quelle épaisseur de béton est nécessaire ?",
    answer: "Pour une terrasse ou allée piétonne : 10-12 cm. Pour un parking ou accès véhicules légers : 12-15 cm. Pour circulation de poids lourds : 15-20 cm avec ferraillage renforcé."
  },
  {
    id: 21,
    category: "Technique",
    question: "Faut-il un hérisson sous le béton ?",
    answer: "Oui, dans la plupart des cas. Une couche de tout-venant compacté de 10-15 cm assure un drainage correct et évite les tassements. L'épaisseur dépend de la nature du sol et de l'utilisation prévue."
  },
  {
    id: 22,
    category: "Technique",
    question: "Le béton désactivé est-il glissant ?",
    answer: "Non, au contraire ! Le béton désactivé est naturellement antidérapant grâce aux granulats en relief. C'est un excellent choix pour les abords de piscine, rampes et zones humides."
  },
  {
    id: 23,
    category: "Technique",
    question: "Peut-on faire du béton décoratif sur un ancien carrelage ?",
    answer: "Généralement non recommandé. Le carrelage ne permet pas une bonne adhérence. Il est préférable de le retirer ou de couler une dalle indépendante par-dessus avec un système d'isolation adapté."
  },
  
  // Applications et Usage
  {
    id: 24,
    category: "Applications",
    question: "Peut-on utiliser le béton imprimé pour une allée de garage ?",
    answer: "Absolument ! Le béton imprimé supporte parfaitement le passage de véhicules. Il faut simplement respecter une épaisseur de 12-15 cm minimum et un ferraillage adapté. C'est une alternative élégante au goudron."
  },
  {
    id: 25,
    category: "Applications",
    question: "Le béton décoratif convient-il aux abords de piscine ?",
    answer: "Oui, c'est même un choix très populaire. Le béton désactivé est particulièrement adapté car antidérapant. Nous utilisons des traitements spécifiques résistants au chlore et aux UV pour les zones piscine."
  },
  {
    id: 26,
    category: "Applications",
    question: "Peut-on faire du béton imprimé en intérieur ?",
    answer: "Oui, le béton imprimé peut être utilisé en intérieur pour des espaces commerciaux, showrooms ou garages. La mise en œuvre diffère légèrement et nécessite une ventilation adaptée lors de l'application."
  },
  {
    id: 27,
    category: "Applications",
    question: "Quelle pente faut-il prévoir pour une terrasse ?",
    answer: "Une pente d'évacuation de 1 à 2% (1-2 cm par mètre) est recommandée pour éviter la stagnation d'eau. Nous intégrons systématiquement cette pente lors de la réalisation."
  },
  
  // Personnalisation
  {
    id: 28,
    category: "Personnalisation",
    question: "Peut-on personnaliser les couleurs et motifs ?",
    answer: "Absolument ! Nous proposons des dizaines de motifs (pierre, ardoise, bois, brique, pavés) et de nombreuses couleurs. Nous pouvons même créer des motifs personnalisés ou combiner plusieurs teintes."
  },
  {
    id: 29,
    category: "Personnalisation",
    question: "Peut-on imiter la pierre naturelle avec le béton imprimé ?",
    answer: "Oui parfaitement ! Le béton imprimé peut reproduire l'aspect de la pierre naturelle, ardoise, granit ou travertin à un coût bien moindre. Le rendu est très réaliste grâce aux moules professionnels et aux colorations."
  },
  {
    id: 30,
    category: "Personnalisation",
    question: "Peut-on faire plusieurs couleurs sur une même surface ?",
    answer: "Oui, nous pouvons combiner plusieurs couleurs pour créer un effet nuancé, des bordures contrastées ou des motifs géométriques personnalisés. Cela ajoute du caractère et de l'originalité à votre projet."
  },
  
  // Zone et Services
  {
    id: 31,
    category: "Services",
    question: "Quelles sont les zones d'intervention ?",
    answer: "Nous intervenons dans un rayon de 65 km autour de Sainte-Cécile-les-Vignes (84290) : tout le Vaucluse, Bouches-du-Rhône nord, Gard ouest et Drôme sud. Villes principales : Orange, Avignon, Carpentras, Nîmes, Montélimar."
  },
  {
    id: 32,
    category: "Services",
    question: "Intervenez-vous pour les professionnels ?",
    answer: "Oui, nous travaillons avec des particuliers, entreprises, collectivités et constructeurs. Nous adaptons nos interventions aux contraintes professionnelles (horaires, délais, coordination de chantier)."
  },
  {
    id: 33,
    category: "Services",
    question: "Proposez-vous des garanties ?",
    answer: "Oui, nos travaux sont couverts par notre assurance décennale. Nous garantissons la qualité de nos réalisations et restons disponibles pour tout suivi ou conseil après la réalisation."
  },
  {
    id: 34,
    category: "Services",
    question: "Faut-il un permis pour couler du béton décoratif ?",
    answer: "Non pour les surfaces au sol (terrasses, allées). Une déclaration préalable peut être nécessaire si la surface dépasse 20m² et crée une emprise au sol nouvelle. Nous vous conseillons selon votre situation."
  },
  {
    id: 35,
    category: "Services",
    question: "Comment prendre rendez-vous ?",
    answer: "Appelez-nous au 06 52 59 34 41, envoyez un email à contact@duma-expert-beton.fr, ou utilisez notre formulaire de contact en ligne. Nous vous répondons sous 24h et planifions une visite gratuite pour étudier votre projet."
  }
];

export const stats = [
  {
    id: 1,
    value: "11+",
    label: "Années d'Expérience",
    icon: "Award"
  },
  {
    id: 2,
    value: "2000+",
    label: "Projets Réalisés",
    icon: "CheckCircle2"
  },
  {
    id: 3,
    value: "100%",
    label: "Clients Satisfaits",
    icon: "ThumbsUp"
  },
  {
    id: 4,
    value: "500 000m²+",
    label: "Surface Réalisée",
    icon: "Ruler"
  }
];

export const processSteps = [
  {
    id: 1,
    title: "Consultation Gratuite",
    description: "Nous discutons de votre projet, vos besoins et vos préférences esthétiques.",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Devis Personnalisé",
    description: "Nous vous proposons un devis détaillé et transparent adapté à votre budget.",
    icon: "FileText"
  },
  {
    id: 3,
    title: "Planification",
    description: "Nous fixons ensemble les dates d'intervention et préparons le chantier.",
    icon: "Calendar"
  },
  {
    id: 4,
    title: "Réalisation",
    description: "Notre équipe qualifiée réalise votre projet avec expertise et précision.",
    icon: "Wrench"
  },
  {
    id: 5,
    title: "Finitions",
    description: "Nous appliquons les traitements de protection et vérifions la qualité.",
    icon: "CheckCircle"
  },
  {
    id: 6,
    title: "Suivi",
    description: "Nous restons à votre écoute et vous conseillons sur l'entretien.",
    icon: "HeadphonesIcon"
  }
];

// Mock calendar availability (simulated)
export const getAvailableSlots = (date) => {
  // Generate mock slots for demonstration
  const slots = [];
  const hours = [8, 9, 10, 11, 14, 15, 16, 17];
  
  hours.forEach(hour => {
    slots.push({
      time: `${hour}:00`,
      available: Math.random() > 0.3 // 70% chance of being available
    });
  });
  
  return slots;
};